export default function getResource(label, vars = []) {
    const resources = {
        removeAddressLabel: 'Remove address',
        remove: 'Remove',
        editAddressLabel: 'Edit address',
        edit: 'Edit',
        addShippingAddress: 'Add new address',
        showMoreAddresses: 'Show all',
        showLessAddresses: 'Show less',
        deliveryMethod: 'Delivery method',
        setAsDefaultCheckbox: 'Set as default delivery address',
        editShipAddress: 'Edit shipping address',
        addNewShipAddress: 'Add new shipping address',
        cancelButton: 'Cancel',
        continueButton: 'Continue',
        maxShipAddressMessage: `You can have up to ${vars[0]} addresses. Please delete one and try to add again.`,
        areYouSureMessage: 'Are you sure you want to remove this address?',
        removeAddress: 'Remove Address',
        taxExemptAddressLabel: 'Tax-Exempt Address',
        shippingMessage: 'Your gift card will be shipped to this address.',
        useThisAddress: 'Use This Address',
        enterAddressManually: 'Enter address manually',
        maximumAddressesReached: 'Maximum Reached',
        deleteSavedAddresses: 'Please delete one of your saved addresses before adding a new one.',
        ok: 'OK',
        selectNewDefaultAddress: 'Select a New Default Address',
        selectNewDefaultAddressDone: 'Done',
        selectNewDefaultAddressLabel: 'Please select an address to set as your new default.',
        defaultAddressUpdated: 'Your default address has been updated to:',
        defaultAddressUpdatedDone: 'Got It',
        defaultAddressUpdatedTitle: 'New Default Address',
        fedexPickupLabel: 'FedEx Pickup Location',
        pickupLabelCA: 'Canada Post Pickup Point',
        loqateSelectionError: 'Please select an address from the list.'
    };

    return resources[label];
}
